import { apiRequest } from "../utility/Utility";

export const sendOTPEmailToUser = async (email) => {
    try {
        await apiRequest({
            endpoint: "/api/sendMail",
            payload: {
                email,
            },
            returnRaw: true
        });
        return {
            status: 0,
            title: "OTP sent",
            message: "OTP successfully sent. Please check your email.",
        };
    } catch (error) {
        let response = error.response;
        if(response.status === 403){
            return {
                status: 1,
                title: "Exception occured",
                message: "User authenticated but exception occured while sending OTP: " + response.data.message
            };
        }
        //console.error("Exception occured while sending OTP ", error.message);
        const { message = null } = error?.response?.data;
        return {
            status: 1,
            title: "Exception occured",
            message: "Exception occured while sending OTP: " + message ?? error.message,
        };
    }
};